<template>
  <div class="forbid">
    <Modal
        :mask-closable="false"
        v-model="opinionModal"
        title="意见"
        height="500"
    >
      <p slot="header">
        提示
      </p>
      <div style="text-align:center;text-align: left">
        <p style="white-space:pre-wrap;">{{ loginMsg }}</p>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="determine">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "forbid",
  computed: {
    ...mapGetters(["getUserInfo"]),
    loginMsg() {
      return this.getUserInfo.user.loginMsg;
    },
  },
  data() {
    return {
      opinionModal: true,
      companyDate: [],
      title: "全国碳排放数据报送系统"
    };
  },
    beforeRouteLeave(to,from,next){
    this.$Message.warning('此页面禁止跳转，请关闭后重新进入！')
  },
  created() {
    // sessionStorage.clear();
  },
  methods: {
    determine() {
      window.close();
    }
  }
};
</script>

<style lang="less" scoped>
</style>
